import React from 'react';

function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export default function KpiStrip({
  items,
  className = '',
  variant = 'default',
  ariaLabel,
}) {
  return (
    <div
      className={joinClassNames('kpi-strip', `kpi-strip--${variant}`, className)}
      aria-label={ariaLabel}
    >
      {items.map((item) => (
        <article
          key={item.key}
          className={joinClassNames(
            'kpi-card',
            item.featured && 'kpi-card--featured',
            item.tone && `kpi-card--${item.tone}`
          )}
        >
          <div className={joinClassNames('kpi-card-metric', item.unitInline && 'kpi-card-metric--inline')}>
            <strong className={joinClassNames('kpi-card-value', item.valueClassName)}>{item.value}</strong>
            {item.unit && <span className={joinClassNames('kpi-card-unit', item.unitInline && 'kpi-card-unit--inline')}>{item.unit}</span>}
          </div>
          <span className="kpi-card-label">{item.label}</span>
          {item.note && <span className="kpi-card-note">{item.note}</span>}
        </article>
      ))}
    </div>
  );
}